const GripStrengthString = {
  0: "Barely Touching",
  1: "Very Light",
  2: "Light",
  3: "Normal",
  4: "Tight",
  5: "Very Tight",
  6: "Death Grip"
}

const GripStrengthEnum = {
  BarelyTouching: 0,
  VeryLight: 1,
  Light: 2,
  Normal: 3,
  Tight: 4,
  VeryTight: 5,
  DeathGrip: 6
}

export { GripStrengthString, GripStrengthEnum }



// WEBPACK FOOTER //
// ./src/game/enums/GripStrength.js